import { defineMessages } from 'react-intl';

export default defineMessages({
    Header404: {
        id: 'Components.ErrorPage.404.Header',
        defaultMessage: 'This is a 404 page.',
    },
    Text404: {
        id: 'Components.ErrorPage.404.Text',
        defaultMessage: 'That just means \'error\'.  But it sounds more computery this way.',
    },
    Header500: {
        id: 'Components.ErrorPage.500.Header',
        defaultMessage: 'This is an error page.',
    },
    Text500: {
        id: 'Components.ErrorPage.500.Text',
        defaultMessage: 'We don\'t like it any more than you do.',
    },
    ReturnHome: {
        id: 'Components.ErrorPage.ReturnHome',
        defaultMessage: 'Return to the homepage',
    },
});
